
    import '/home/ec2-user/Youlify-Design/components/qr-code/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["qr-code-demo-base","qr-code-demo-icon","qr-code-demo-status","qr-code-demo-customstatusrender","qr-code-demo-type","qr-code-demo-customsize","qr-code-demo-customcolor","qr-code-demo-download","qr-code-demo-errorlevel","qr-code-demo-popover"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/qr-code/index.en-US.md?type=demo')
};